/**
 * Dark institutional boot skeleton while `/design` loads (no cache).
 */
export function BootSkeleton() {
  return (
    <div className="flex h-dvh w-full flex-col bg-[#0B0E11] text-[#848E9C]">
      <div className="flex h-12 items-center gap-2 border-b border-[#2B313A] px-3">
        <div className="h-5 w-20 animate-pulse rounded-sm bg-[#181A20]" />
        <div className="h-7 w-28 animate-pulse rounded-sm bg-[#181A20]" />
        <div className="ms-auto flex gap-1.5">
          <div className="h-7 w-14 animate-pulse rounded-sm bg-[#181A20]" />
          <div className="h-7 w-7 animate-pulse rounded-sm bg-[#181A20]" />
          <div className="h-7 w-7 animate-pulse rounded-sm bg-[#181A20]" />
        </div>
      </div>
      <div className="flex min-h-0 flex-1">
        <div className="hidden w-52 shrink-0 border-e border-[#2B313A] p-2 lg:block">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="mb-1.5 h-8 animate-pulse rounded-sm bg-[#181A20]"
              style={{ animationDelay: `${i * 70}ms` }}
            />
          ))}
        </div>
        <div className="flex min-w-0 flex-1 flex-col items-center justify-center gap-3 p-6">
          <div
            className="h-9 w-9 rounded-full border-2 border-terminal-border border-t-accent animate-spin"
            aria-hidden
          />
          <p className="text-[10px] tracking-[0.25em] uppercase text-[#848E9C]">
            Initializing
          </p>
        </div>
      </div>
    </div>
  )
}
